import React, { useCallback, useEffect, useMemo, useState } from "react";
import toastr from "toastr";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { connect, useDispatch, useSelector } from "react-redux";
import { useForm } from "app/_helpers/hooks";
import { validateRowFilter } from "../IncidentManagement/CONSTANTS";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiPlusCircle, FiEdit3, FiEdit, FiEye } from "react-icons/fi";
import { FaRegTrashAlt } from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import TableExport from "app/views/custom/components/Export/TableExport";
import { getAllCapas, deleteCapa, revertedCapa } from "app/_services/ehs/ehsCapaServices";
import { capaPriorities, capaStatuses } from "../IncidentManagement/CONSTANTS";
import { isBetween } from "app/_helpers/dateHelper";
import { formatDDMMYYYYbyYYYYMMDD } from "app/_helpers/helper";
import CompletionProof from "./CompletionProof";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { filterActionAdd } from "../TrainingManagement/Assign/ReducerForAssign";
import { YYYYMMDDFormat } from "app/_helpers/dateHelper";
import { EFormFieldInputTypes } from "app/Components/Form/FormField.component";
import { capaFilterFields } from "../IncidentManagement/CONSTANTS";
import {
  checkStringsAreEqual,
  getLoggedInUserId,
  isUserMM,
  isUserSO,
  isUserVFLOfficer,
} from "../IncidentManagement/Helper";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import { ACTIVE_MODULE, moduleType } from "app/_constants/constant";
import { MdRefresh } from "react-icons/md";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import Decline from "../IncidentManagement/DeclinePopup";
import CapaFilter from "./CapaFilter";
import { tr } from "date-fns/locale";
import { GiReturnArrow } from "react-icons/gi";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
import DeleteRecordIcon from "app/Components/DeleteRecordIcon/DeleteRecordIcon";
const ManageCapa = ({
  match: {
    params: { siteId },
  },
}) => {
  const [tab, setTab] = useState(1);
  const [tabCount, setTabCount] = useState();
  const [revertCapaCount, setRevertCapaCount] = useState();
  const filterStatus = useSelector((state) => state.filterReducerTraining);
  const dispatchFunction = useDispatch();
  const [searchFilter, setSearchFilter] = useState();
  const [capas, setCapas] = useState([]);
  const [capasFilter, setCapasFilter] = useState([]);
  const [filterForm, onChangeFilter, setFilterForm] = useForm({}, capaFilterFields);
  const [showFilter, setShowFilter] = useState(false);
  const [finalCapasFilter, setFinalCapasFilter] = useState([]);
  // const [MyCapaCount, setMyCapaCount] = useState("");
  const [capaHistory, setCapaHistory] = useState(0);
  const [viewCapa, setViewCapa] = useState(0);
  // const [RetunedCapa, setRetunedCapa] = useState("");
  const [loading, setLoading] = useState(true);
  const onReset = () => setFilterForm({});
  const deleteCapaById = (id) => {
    confirmAlert({
      title: "Delete CAPA.",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const response = await deleteCapa(id);

            if (!response?.status) return toastr.error(response?.message);

            toastr.success("Success.");

            setCapas((prev) => prev.filter((data) => data.id !== id));
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const revertCapa = (capaId, obj) => {
    revertedCapa(capaId, obj).then((response) => {
      if (response?.status) toastr.success("Returned Successfully");
      capasList();
    });
  };

  const deleteRow = (id) => {
    confirmAlert({
      title: "Delete CAPA",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            let response = await deleteCapa(id);

            if (!response?.status) return toastr.error(response?.message);

            toastr.info(response?.message || "Deleted Successfully!");
            capasList();
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const onSearchFilter = (props) => {
    let value = props?.searchProps?.searchText;
    if (searchFilter?.search !== props?.searchProps?.searchText) setSearchFilter(value);
  };

  useEffect(() => {
    dispatchFunction(filterActionAdd({ manageCapaSearch: searchFilter }));
  }, [searchFilter]);

  const { SearchBar } = Search;
  const sortableColumn = useMemo(
    () => [
      {
        dataField: "sid",
        text: "S.No.",
        sort: false,
      },
      {
        dataField: "site.name",
        text: "Location Name",
        sort: true,
        formatter: (site, row) => {
          return `${row?.site?.name}`;
        },
      },
      {
        dataField: "site.siteId",
        text: "Location ID",
        sort: true,
        formatter: (site, row) => {
          return `${row?.site?.siteId}`;
        },
      },
      {
        dataField: "sourceName",
        text: "Source Type",
        sort: true,
      },
      {
        dataField: "workArea.name",
        text: "Source Area",
        sort: true,
      },
      {
        dataField: "capaId",
        text: "CAPA ID",
        sort: true,
      },
      {
        dataField: "solution",
        text: "CAPA Description",
        sort: true,
        classes: "text-wrap",
      },
      {
        dataField: "priority",
        text: "Priority",
        sort: true,
        formatter: (rowContent) => capaPriorities[rowContent],
      },
      {
        dataField: "ownerName",
        text: "CAPA Owner",
        sort: true,
      },
      {
        dataField: "dueDate",
        text: "Due Date",
        sort: true,
        formatter: (rowContent) => formatDDMMYYYYbyYYYYMMDD(rowContent),
      },
      {
        dataField: "capaStatus",
        text: "CAPA Status",
        //  sort: true,
        formatter: (rowContent, row) => {
          let className = "sucess";

          switch (rowContent) {
            case capaStatuses.closed:
              className = "success";
              break;
            case capaStatuses.open:
              className = "orange text-white rounded text-center";
              break;
            case capaStatuses.due:
              className = "yellow text-white rounded text-center";
              break;
            case capaStatuses.overdue:
              className = "red-500 text-white rounded text-center";
              break;
            default:
              className = "success";
          }

          return (
            <div
              className={
                !row?.reverted ? className : "bg-primary text-white rounded text-center"
              }
            >
              {!row?.reverted ? (
                rowContent
              ) : (
                <>
                  Returned <GiReturnArrow className="ml-2" size={18} />
                </>
              )}
            </div>
          );
        },
      },
      {
        dataField: "formattedCompletionProof",
        text: "Completion Proof",
        sort: true,
        formatter: (rowContent, row) => {
          return row?.completionProof ? (
            <CompletionProof file={row?.completionProof} />
          ) : (
            ""
          );
        },
      },
      {
        dataField: "id",
        text: "Action",
        formatter: (id, row) => {
          return (
            <div className="actionIconsGroup">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">View</Tooltip>}
              >
                <Link
                  to={
                    (siteId ? `/sites/${siteId}` : "") +
                    "/health-safety-and-environment/capa-management/manage-capa/view/" +
                    row?.id
                  }
                  className="icons text-cyanBlue"
                >
                  <FiEye />
                </Link>
              </OverlayTrigger>

              {row?.capaStatus !== "Completed" && !row?.reverted && tab === 1 && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Update</Tooltip>}
                >
                  <Link
                    to={
                      (siteId ? `/sites/${siteId}` : "") +
                      "/health-safety-and-environment/capa-management/manage-capa/update/" +
                      row?.id
                    }
                    className="icons text-cyanBlue"
                  >
                    <FiEdit />
                  </Link>
                </OverlayTrigger>
              )}
              {row?.capaStatus !== "Completed" && tab === 4 && (
                <>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Update</Tooltip>}
                  >
                    <Link
                      to={
                        (siteId ? `/sites/${siteId}` : "") +
                        "/health-safety-and-environment/capa-management/manage-capa/capa-update/" +
                        row?.id
                      }
                      className="icons text-cyanBlue"
                    >
                      <FiEdit />
                    </Link>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                  >
                    <span
                      onClick={() => deleteRow(row?.id)}
                      className="icons text-danger pointer"
                    >
                      <FaRegTrashAlt />
                    </span>
                  </OverlayTrigger>
                </>
              )}
              {row?.capaStatus !== "Completed" && !row?.reverted && tab === 1 && (
                <Decline
                  onSubmit={(obj) => revertCapa(row?.id, { revertMessage: obj.comment })}
                  title="Return"
                  name={
                    <CustomTooltip tooltip="Return">
                      <MdRefresh size={20} />
                    </CustomTooltip>
                  }
                  iconClass={"icons text-cyanBlue"}
                />
              )}
              {tab === 3 && (
                <DeleteRecordIcon
                  id={row.id}
                  moduleType={moduleType.ehsCapa}
                  setLoading={setLoading}
                  reloadData={capasList}
                />
              )}
            </div>
          );
        },
      },
    ],
    [siteId, tab]
  );
  const rowStyle = (row) => {
    if (row?.reverted && tab !== 4) {
      return { backgroundColor: "#d2ced6" };
    }
  };
  const capasList = useCallback(() => {
    getAllCapas(siteId ? `filter[siteId]=${siteId}` : "").then((response) => {
      if (!response?.status) {
        setLoading(false);
        return;
      }
      setCapas(
        response.data.map((data, index) => {
          return {
            ...data,
            sid: index + 1,
            formattedCompletionProof: !!data?.completionProof
              ? data?.completionProof?.real_document_name
              : "",
            ownerName: data?.owner
              ? `${data?.owner?.firstName} ${data?.owner?.lastName}`
              : "",
            sourceName: `${
              data?.source === "ehs_vfl_observations" ? "VFL" : data?.source
            }`,
            capaStatus: data?.reverted ? "Returned" : data?.capaStatus,
          };
        })
      );
      setLoading(false);
    });
  }, [siteId]);

  useEffect(() => {
    capasList();
  }, [capasList]);

  useEffect(() => {
    setCapasFilter(
      capas.filter((row) => {
        let TRUE_FALSE = false;
        if (
          tab === 1 &&
          getLoggedInUserId() === row?.ownerId &&
          row.capaStatus !== capaStatuses.completed
        ) {
          TRUE_FALSE = true;
        }
        if (
          tab === 2 &&
          getLoggedInUserId() === row?.ownerId &&
          row.capaStatus === capaStatuses.completed
        ) {
          TRUE_FALSE = true;
        }
        if (tab === 3) {
          TRUE_FALSE = true;
        }

        if (isUserVFLOfficer())
          if (tab === 4 && row?.reverted && row?.source === "ehs_vfl_observations") {
            TRUE_FALSE = true;
          }
        if (isUserSO() || isUserMM())
          if (tab === 4 && row?.reverted && row?.source === "Incident Management") {
            TRUE_FALSE = true;
          }
        return TRUE_FALSE;
      })
    );
  }, [capas, tab]);

  //count for my capa and capa
  useEffect(() => {
    let viewCapa = capas.length;
    let capaHistory = 0;

    capas.forEach((row) => {
      if (
        getLoggedInUserId() === row?.ownerId &&
        row.capaStatus === capaStatuses.completed
      ) {
        capaHistory++;
      }
    });
    setCapaHistory(capaHistory);
    setViewCapa(viewCapa);
  }, [capas]);

  useEffect(() => {
    setFinalCapasFilter(
      capasFilter?.filter?.((data) => {
        let flag = true;
        if (filterForm?.startDate && filterForm?.endDate) {
          flag = isBetween(
            data.dueDate,
            YYYYMMDDFormat(filterForm.startDate),
            YYYYMMDDFormat(filterForm.endDate)
          );
        }

        if (filterForm?.capaStatus && flag) {
          if (filterForm?.capaStatus !== "revert") {
            if (data?.capaStatus === filterForm?.capaStatus) flag = true;
            else flag = false;
          } else {
            if (data.reverted === 1) flag = true;
            else flag = false;
          }
        }

        if (flag) flag = validateRowFilter(filterForm, data);
        return flag;
      })
    );
  }, [filterForm, capasFilter]);

  useEffect(() => {
    if (tab === 1) setTabCount(capasFilter?.length);
  }, [capasFilter?.length, tab]);

  useEffect(() => {
    const userId = getLoggedInUserId();
    let isCount = 0;
    let vflCount = 0;
    let incidentCount = 0;
    if (isUserVFLOfficer())
      vflCount = capas.filter(
        (row) => row?.source === "ehs_vfl_observations" && row?.reverted
      )?.length;

    if (isUserSO() || isUserMM())
      incidentCount = capas.filter(
        (row) => row?.source === "Incident Management" && row?.reverted
      )?.length;
    isCount = vflCount + incidentCount;
    setRevertCapaCount(isCount);
  }, [capas]);

  const tabClick = (tab) => {
    setCapasFilter([]);
    setTab(tab);
  };

  const tableToolbarBeforeView = () =>
    showFilter && (
      <CapaFilter
        fields={capaFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChangeFilter}
        onReset={onReset}
      />
    );

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "CAPA Management",
            path: "/health-safety-and-environment/capa-management",
          },

          { name: "Manage CAPA" },
        ]}
        module={ACTIVE_MODULE.capa}
      />
      <div className="card p-3">
        <div className="simple-card-title">
          <h3 class="text-capitalize mb-1">Manage CAPA</h3>
          <FilterBtn setShowFilter={setShowFilter} />
          <BackBtn
            url={
              (siteId ? `/sites/${siteId}` : "") +
              "/health-safety-and-environment/capa-management"
            }
          />
        </div>
        <div className="healthSafetyEnvironmentWrapper EHS_module_tabber mb-2">
          <div className="hseMenuLinks card">
            <a
              href
              onClick={() => tab !== 1 && tabClick(1)}
              className={`pointer${tab === 1 ? " active" : ""}`}
            >
              My CAPAs ({tabCount})
            </a>
            <a
              href
              onClick={() => tab !== 2 && tabClick(2)}
              className={`pointer${tab === 2 ? " active" : ""}`}
            >
              My CAPAs History({capaHistory})
            </a>
            <a
              href
              onClick={() => tab !== 3 && tabClick(3)}
              // style={{pointerEvents: 'none'}}
              className={`pointer${tab === 3 ? " active" : ""}`}
            >
              View CAPAs ({viewCapa})
            </a>
            {revertCapaCount && (isUserVFLOfficer() || isUserSO() || isUserMM()) ? (
              <a
                href
                onClick={() => tab !== 4 && tabClick(4)}
                // style={{pointerEvents: 'none'}}
                className={`pointer${tab === 4 ? " active" : ""}`}
              >
                Returned CAPAs ({revertCapaCount})
              </a>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="material-master-table">
          {!loading ? (
            <SearchBootstrapTable
              rowStyle={rowStyle}
              searchKey={"manageCAPADesktopSearch"}
              data={finalCapasFilter.map((d, idx) => ({ ...d, sid: idx + 1 }))}
              columns={sortableColumn}
              tableKey="manageCAPA"
              defaultHideColumn={["site.siteId", "solution"]}
              tableBeforeSearch={tableToolbarBeforeView}
            />
          ) : (
            <NetZeroLoader />
          )}
          <br />
        </div>
      </div>
    </div>
  );
};

export default ManageCapa;
